import constants from "../../core/constants";

import { has } from "lodash/fp";

const deductionPriceType = [
  { name: "percentage", display: "Percentage (%)" },
  { name: "fixed", display: "Fixed" },
];

class Controller {
  constructor($injector, $stateParams, $mdDialog) {
    "ngInject";
    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Sections = $injector.get("Sections");
    this.DeductionPlan = $injector.get("DeductionPlan");
    this.DeductionPlanTransforms = $injector.get("DeductionPlanTransforms");

    this.onUpdateEvent = this.Events.getUpdateEvent("deductionPlan");

    this.sections = this.Sections.plansSections;
    this.enableEdit = false;
    this.$mdDialog = $mdDialog;

    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }

  $onInit() {
    this.deductionPlanTypes = deductionPriceType;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onUpdate = (options) => {
      const params = {};

      params[options.key] =
        typeof options.value !== "undefined"
          ? options.value
          : options.name
          ? options.name._id
          : null;
      if (options.key === "delay_deduction") {
        params[options.key] = options.value * constants.currencyBy;
      }

      this.DeductionPlan.update(this.$stateParams.id, params).$promise.then(
        () => {
          this.deductionPlan[options.key].isDisabled = true;
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("deduction plan", options.key)
          );
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };
    this.getRideLateDeductionPlans();
    this.Events.on(this.onUpdateEvent, onUpdate);
  }

  getRideLateDeductionPlans() {
    this.DeductionPlan.get(this.$stateParams.id).$promise.then((response) => {
      this.deductionPlan = this.DeductionPlanTransforms.justify(response);
    });
  }
  onUpdateRideLateDeduction(options) {
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const params = {};

    params[options.key] =
      typeof options.value !== "undefined"
        ? options.value
        : options.name
        ? options.name._id
        : null;
    options.key = "ride_late_deduction";
    options.isDisabled = true;
    params[options.key] = options.map((option) => {
      const type = option.type;
      const tempOption = {};
      if (
        !(typeof type === "string" || type instanceof String) &&
        has("name")(type) &&
        has("display")(type)
      ) {
        tempOption.type = option.type.name;
        tempOption.threshold = option.threshold * constants.fromMinToMilli;
        if (tempOption.type === "percentage") {
          tempOption.amount = option.amount / constants.percentage;
        } else {
          tempOption.amount = option.amount * constants.currencyBy;
        }
      }
      return tempOption;
    });
    this.DeductionPlan.update(this.$stateParams.id, params).$promise.then(
      () => {
        this.deductionPlan[options.key].isDisabled = true;
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("deduction plan", options.key)
        );
      },
      (response) => this.Events.emit(errorEvent, response.data)
    );
  }
}
export default Controller;



// WEBPACK FOOTER //
// ./src/pages/deductionPlan/deductionPlan.controller.js